import type { FC, PropsWithChildren } from 'react'

import { Button } from 'antd'
import { Link } from 'react-router'

import styles from './mcm-link.module.css'

import type { ButtonProps } from 'antd'
import type { LinkProps } from 'react-router'

type TProps = LinkProps & {
  buttonProps?: ButtonProps
}

const McmLink: FC<PropsWithChildren<TProps>> = ({
  children,
  buttonProps,
  ...props
}) => (
  <Link {...props}>
    <Button
      className={styles.link}
      variant='link'
      color='default'
      {...buttonProps}
    >
      {children}
    </Button>
  </Link>
)

export default McmLink
